module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Add","empty":"No peek results","open":"Open","peek":"Peek"}}')
  delete Component.options._Ctor
}
